var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmoneyIcon = function SvgEmoneyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    fillRule: "evenodd",
    d: "M9.69 19.972c5.352 0 9.69-4.338 9.69-9.69S15.042.592 9.69.592 0 4.931 0 10.282c0 5.352 4.338 9.69 9.69 9.69M8.562 15.07c2.476 0 4.355-2.34 5.55-4.679l-.256-.203c-1.195 2.237-2.903 4.577-5.294 4.577-1.025 0-1.452-.916-1.452-2.035 0-.508.086-1.118.256-1.728 1.794-.509 4.953-1.933 4.953-4.679 0-.915-.427-1.322-1.195-1.322C8.39 5 6 9.17 6 12.12c0 1.83 1.025 2.949 2.562 2.949m2.366-9.611c.445 0 .623.422.623.845 0 2.64-2.402 3.907-4.27 4.647.445-1.69 1.779-5.492 3.647-5.492",
    clipRule: "evenodd"
  })));
};
export default SvgEmoneyIcon;